'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function memoize(fn) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _options_cache = options.cache, cache = _options_cache === void 0 ? new Map() : _options_cache, getCacheKey = options.getCacheKey;
    var memoizedFn = function memoizedFn(arg) {
        var key = getCacheKey ? getCacheKey(arg) : arg;
        if (cache.has(key)) {
            return cache.get(key);
        }
        var result = fn.call(this, arg);
        cache.set(key, result);
        return result;
    };
    memoizedFn.cache = cache;
    return memoizedFn;
}
exports.memoize = memoize;
